import Touchable from "../../components/ui/Touchable";
import Text from "../../components/ui/Text";
import useStore from "../../hooks/store/useStore";
import useEventTracking from "../../services/EventTracking/useEventTracking";
import { tabletMaxWidth } from "../../constants/layout";
import cn from "../../utils/cn";
import openDownloadPage from "../webLogin/utils/openDownloadPage";
import { BookButtonWebHeight } from "./constants";

export default function BookButtonWeb({
  leftButtonText,
  rightButtonText,
  onClick,
}: {
  leftButtonText: string;
  rightButtonText: string;
  onClick?: () => void;
}) {
  const { userInformation } = useStore((state) => state.user);
  const { market, trialUserSegmentation: seg } = userInformation || {};
  const hideBookDemo = seg === "Decision";

  const mutation = useEventTracking();

  const handleEventTracking = () => {
    mutation.mutate({
      pageId: "App Download",
      eventId: "Bottom Button",
    });
  };

  const handleDownloadClick = () => {
    handleEventTracking();

    if (market) openDownloadPage(market);
  };

  const buttonStyle = "flex items-center justify-center";

  return (
    <div
      className="fixed bottom-0 left-1/2 z-[5] flex w-full -translate-x-1/2"
      style={{ maxWidth: tabletMaxWidth }}
    >
      <Touchable
        className={cn(
          buttonStyle,
          BookButtonWebHeight,
          "bg-disneyGold",
          hideBookDemo ? "w-full rounded-t-xl" : "w-1/2 rounded-tl-xl",
        )}
        style={{ boxShadow: "-2px 2px 32px rgba(29, 29, 29, 0.10)" }}
        onClick={handleDownloadClick}
      >
        <Text className="text-nowrap text-white">{leftButtonText}</Text>
      </Touchable>

      {hideBookDemo ? null : (
        <Touchable
          className={cn(
            buttonStyle,
            BookButtonWebHeight,
            "w-1/2 rounded-tr-xl bg-white/25 backdrop-blur",
          )}
          style={{ boxShadow: "2px 2px 32px rgba(29, 29, 29, 0.10)" }}
          onClick={onClick}
        >
          <Text className="text-nowrap text-black8">{rightButtonText}</Text>
        </Touchable>
      )}
    </div>
  );
}
